const setDateHourToMidnight = date => {
  date.setUTCHours(0, 0, 0, 0)
  return date.toISOString()
}

export default setDateHourToMidnight
